export enum MAIN_LINKS {
  DASHBOARD = 'Dashboard',
  FREELANCERS = 'Freelancers',
  DOCUMENTS = 'Documents',
  CLIENTS = 'Clients',
  PROJECT_OPPORTUNITIES = 'Project opportunities',
  JOB_BOARD = 'Job Board'
};

export enum SUPPORT_LINKS {
  SETTINGS = 'Settings',
}

//getPath is designed to be a function in order to build the path dynamically when needed.
export type SubLinkProp = {
  name: string,
  getPath: (args?: any) => string
}

export type LinkProp = {
  getPath: (args?: any) => string,
  icon?: string,
  subTabs: SubLinkProp[]
}